import { Controller } from "@hotwired/stimulus"

// Shows a skeleton while a turbo-frame fetches (src load or in-frame refresh).
export default class extends Controller {
  static targets = ["skeleton", "content"]

  connect() {
    this.#syncFromFrameState()

    this.element.addEventListener("turbo:before-fetch-request", this.showSkeleton)
    this.element.addEventListener("turbo:frame-load", this.hideSkeleton)
    this.element.addEventListener("turbo:frame-render", this.hideSkeleton)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-fetch-request", this.showSkeleton)
    this.element.removeEventListener("turbo:frame-load", this.hideSkeleton)
    this.element.removeEventListener("turbo:frame-render", this.hideSkeleton)
  }

  showSkeleton = (event) => {
    // Ignore bubbled prefetch/navigation events from links inside the frame (e.g. modal)
    if (event && event.target !== this.element) return

    if (this.hasSkeletonTarget) this.skeletonTarget.classList.remove("hidden")
    if (this.hasContentTarget) this.contentTarget.classList.add("hidden")
  }

  hideSkeleton = () => {
    if (this.hasSkeletonTarget) this.skeletonTarget.classList.add("hidden")
    if (this.hasContentTarget) this.contentTarget.classList.remove("hidden")
  }

  #syncFromFrameState() {
    const awaitingSrc = this.element.hasAttribute("src") && !this.element.hasAttribute("complete")
    const busy = this.element.hasAttribute("busy")

    if (awaitingSrc || busy) {
      this.showSkeleton()
    } else {
      this.hideSkeleton()
    }
  }
}
